import React, { useEffect, useState } from 'react'
import Loader from 'components/ContentBox/Global/Loader/Loader'
import { superAxiosRequest } from 'axiosApi'
import { observer } from 'mobx-react'
import styles from './MoneyLogsInfo.module.scss'
import { BlockHeader } from 'components/UI/BlockHeader/BlockHeader'
import { GoToLink } from 'components/UI/SuperButton/SuperButton'
import LocalStorage from 'services/LocalStorage'
import Pagination from 'components/UI/Pagination/Pagination'
import { useParams } from 'react-router-dom'

const initPagination = {
  page: 1,
  limit: 10,
}

const formatDateAndTime = (timestamp, lang = 'en') => {
  const date = new Date(timestamp)
  let locale
  if (lang === 'ru') {
    locale = 'ru-RU'
  } else if (lang === 'kz' || lang === 'kk') {
    locale = 'kk-KZ'
  } else {
    locale = 'en-US'
  }
  const time = date.toLocaleTimeString(locale, {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  })
  const day = date.getDate()
  const month = date.toLocaleString(locale, { month: 'long' })
  const year = date.getFullYear()
  const formattedDate = `${day} ${month} ${year}`
  return { time, formattedDate }
}

const MoneyLogsInfo = ({ client: propClient, shortForm }) => {
  const [data, setData] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [pagination, setPagination] = useState(
    shortForm ? { page: 1, limit: 5 } : initPagination,
  )
  const [clientData, setClientData] = useState(null)

  const { id: clientId } = useParams()
  const ud = LocalStorage.get('ud')
  const userData = ud?.user_data?.profile
  const lang = userData?.localization?.toLowerCase() || 'en'

  const currentClient = propClient || clientData

  useEffect(() => {
    if (!propClient && clientId) {
      const apiConf = {
        method: 'get',
        link: 'accounts/clients/' + clientId,
      }
      superAxiosRequest(apiConf)
        .then((response) => {
          setClientData(response.data)
        })
        .catch((error) => {
          console.error(error)
          setIsLoading(false)
        })
    }
  }, [clientId, propClient])

  useEffect(() => {
    if (!currentClient?.profile?.id) return

    const params = shortForm
      ? { client: currentClient.profile.id, limit: 5 }
      : {
          client: currentClient.profile.id,
          offset: (pagination.page - 1) * pagination.limit,
          limit: pagination.limit,
        }

    setIsLoading(true)
    superAxiosRequest({
      link: `ledger/client_coins`,
      method: 'get',
      params,
    })
      .then(({ data }) => {
        setData(data)
      })
      .catch((er) => {
        console.error(er)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [pagination, shortForm, currentClient?.profile?.id])

  if (!currentClient) {
    return <Loader />
  }

  return (
    <div className={styles.main}>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <BlockHeader title={'Interpress Money Logs'}>
            {shortForm && data?.result?.length !== 0 && (
              <GoToLink target={'_blank'} to={`/money/${currentClient.id}`} />
            )}
          </BlockHeader>
          <div>
            {data?.result?.length ? (
              data?.result?.map((log, index) => {
                const { time, formattedDate } = formatDateAndTime(
                  log.created_at,
                  lang,
                )
                return (
                  <div
                    key={index}
                    className={`${styles.logItem}  ${
                      index % 2 === 0 ? styles.logContentColored : ''
                    }`}
                  >
                    <div className={styles.logContent}>
                      <div>
                        <div>
                          {`${log?.sum > 0 ? 'Пополнение' : 'Списание'}`} на
                          сумму {log?.sum} менеджером{' '}
                          {log?.created_by?.full_name}{' '}
                        </div>
                        {log?.comment && (
                          <div>
                            <strong> Комментарий: </strong>
                            {log?.comment}
                          </div>
                        )}
                      </div>
                      <div className={styles.logDetails}>
                        <span className={styles.time}>{time}</span>
                        <span className={styles.date}>{formattedDate}</span>
                      </div>
                    </div>
                  </div>
                )
              })
            ) : (
              <div className={styles.noData}>No data available</div>
            )}
          </div>
          {!shortForm && data?._meta?.count_items > 10 && (
            <div className={styles.pagination}>
              <Pagination
                limit={pagination.limit}
                count={data._meta?.count_items || 0}
                page={pagination.page}
                onChange={(page) => setPagination({ ...pagination, page })}
                onChangePerPage={(limit) => {
                  setPagination({ page: 1, limit })
                }}
              />
            </div>
          )}
        </>
      )}
    </div>
  )
}

export default observer(MoneyLogsInfo)
